import FormInstance from './form-instance';
export default function useForm(initialValues) {
    if (initialValues === void 0) { initialValues = {}; }
    return [new FormInstance(initialValues)];
}
//# sourceMappingURL=use-form.js.map